import { Text, ListItemButton, ListItemIcon, ListItemText } from '@shared/components';

import type { NavMenuItemProps } from './nav-menu-item';
import TooltipMenu from './tooltip-menu';

type MenuItemProps = {
  onClick?: () => void;
} & Pick<NavMenuItemProps, 'label' | 'icon' | 'minified'>;

function MenuItem(props: Readonly<MenuItemProps>) {
  const { icon: iconProp, label: labelProp, onClick, minified: isMinified } = props;

  const isStaticMenu = !onClick;

  let icon;
  let label;

  if (iconProp) {
    icon = <ListItemIcon>{iconProp}</ListItemIcon>;
  }
  if (labelProp && !isMinified) {
    if (typeof labelProp === 'string') {
      label = <Text variant='body1'>{labelProp}</Text>;
    } else {
      label = labelProp;
    }
  }

  const tooltipContent = (
    <ListItemText>
      <Text variant='body2' fontWeight={600}>
        {labelProp}
      </Text>
    </ListItemText>
  );

  return (
    <TooltipMenu title={isMinified ? tooltipContent : ''}>
      <ListItemButton
        component='li'
        onClick={onClick}
        disableRipple={isStaticMenu}
        sx={isStaticMenu ? { '&:hover': { bgcolor: 'inherit', cursor: 'default' } } : null}
      >
        {icon}
        {label}
      </ListItemButton>
    </TooltipMenu>
  );
}

export type { MenuItemProps };
export default MenuItem;
